import React, { useState } from "react"
import { Button } from "../../../components/ui/button"
import { Badge } from "../../../components/ui/badge"
import { Card, CardContent, CardHeader, CardTitle } from "../../../components/ui/card"
import { Separator } from "../../../components/ui/separator"
import { Copy, Package } from "lucide-react"
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../../../components/ui/tabs"
import { Sheet, SheetContent, SheetHeader, SheetTitle } from "../../../components/ui/sheet"

const ProductCategoryDetailView = ({ category, open, onOpenChange }: any) => {
    const [copied, setCopied] = useState(false)
    const [activeTab, setActiveTab] = useState("overview")

    if (!category) return null

    const copyToClipboard = (text: string) => {
        navigator.clipboard.writeText(text)
        setCopied(true)
        setTimeout(() => setCopied(false), 2000)
    }

    return (
        <Sheet open={open} onOpenChange={(event) => onOpenChange(null, event)}>
            <SheetContent side="right" className="w-full min-w-[600px] p-0 overflow-auto">
                <SheetHeader className="bg-gradient-to-r from-purple-50 to-blue-50 p-6 border-b detail-header">
                    <div className="flex items-center justify-between">
                        <div className="flex items-center space-x-3">
                            <div className="bg-purple-100 p-2 rounded-lg">
                                <Package className="h-6 w-6 text-purple-600" />
                            </div>
                            <div>
                                <SheetTitle className="text-xl font-bold text-gray-900">{category.categoryName}</SheetTitle>
                                <p className="text-sm text-gray-600 mt-1">{category.description}</p>
                            </div>
                        </div>
                    </div>

                    <Button variant="outline" onClick={() => onOpenChange(null, false)} className="close-panel">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-x h-4 w-4"><path d="M18 6 6 18"></path><path d="m6 6 12 12"></path></svg>
                    </Button>
                </SheetHeader>


                <Tabs defaultValue="overview" className="w-full" onValueChange={setActiveTab}>
                    {/* <div className="px-6 pt-6">
                        <TabsList className="grid w-full grid-cols-1">
                            <TabsTrigger value="overview">Overview</TabsTrigger>
                        </TabsList>
                    </div> */}

                    <div className="p-6 overflow-y-auto">
                        <TabsContent value="overview" className="mt-0">
                            <Card>
                                <CardHeader>
                                    <CardTitle>Product Category Information</CardTitle>
                                </CardHeader>
                                <CardContent className="space-y-4">
                                    <div className="grid grid-cols-2 gap-4">
                                        {/* <div>
                                            <p className="text-sm text-gray-500">ID</p>
                                            <div className="flex items-center">
                                                <p className="font-mono text-sm truncate">{category.id ? category.id.substring(0, 12) + '...' : 'N/A'}</p>
                                                {category.id && (
                                                    <Button
                                                        variant="ghost"
                                                        size="icon"
                                                        className="h-6 w-6 ml-1"
                                                        onClick={() => copyToClipboard(category.id)}
                                                    >
                                                        <Copy className="h-3 w-3" />
                                                    </Button>
                                                )}
                                            </div>
                                        </div> */}
                                        <div>
                                            <p className="text-sm text-gray-300">Category Name</p>
                                            <p className="font-medium">{category.categoryName}</p>
                                        </div>
                                        <div>
                                            <p className="text-sm text-gray-300">System Field</p>
                                            <Badge variant={category.isSystemField ? "default" : "secondary"}>
                                                {category.isSystemField ? "Yes" : "No"}
                                            </Badge>
                                        </div>
                                        <div className="col-span-2">
                                            <p className="text-sm text-gray-300">Description</p>
                                            <p className="font-medium">{category.description}</p>
                                        </div>
                                    </div>
                                    <Separator />
                                </CardContent>
                            </Card>
                        </TabsContent>
                    </div>
                </Tabs>
                {/* <div className="border-t p-6 flex justify-end gap-2">
                </div> */}
            </SheetContent>
        </Sheet>
    )
}

export default ProductCategoryDetailView;
